import { render, staticRenderFns } from "./NxFooter.vue?vue&type=template&id=26f38be2&scoped=true"
import script from "./NxFooter.vue?vue&type=script&lang=js"
export * from "./NxFooter.vue?vue&type=script&lang=js"
import style0 from "./NxFooter.vue?vue&type=style&index=0&id=26f38be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f38be2",
  null
  
)

export default component.exports